import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiPaper-root": {
		  backgroundColor: '#fff',
		  color: '#000'
		}
	},
	icon:{
		fontSize: '4em'
	},
	colorGreen:{
		color: '#7C9E3D'
	},
	colorYellow:{
		color: '#DAAA00'
	},
	dialogContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	},
	dialogActions: {
		justifyContent: 'center',
		paddingBottom: '40px'
	},
	openNotification: {
		color: '#000'
	},
	closeModal: {
		width: '8rem',
		height: '3rem',
		borderRadius: 0
	}
}));

export default useStyles;
